import * as D from './deps';

export function actionPause({
  deviceProperties,
  deviceUuid,
  elapsedTime,
  index,
  onUnload,
  pandoraId,
  sourceId,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.ACTION_PAUSE,
    content: {
      deviceProperties,
      deviceUuid,
      elapsedTime,
      index,
      pandoraId,
      sourceId,
      sync: onUnload,
    },
  });
}

export function actionPrevious({ deviceProperties, deviceUuid, elapsedTime, index, sourceId }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.ACTION_PREVIOUS,
    content: {
      deviceProperties,
      deviceUuid,
      elapsedTime,
      includeItem: true,
      index,
      sourceId,
    },
  });
}

export function actionRemoveThumb({
  deviceProperties,
  deviceUuid,
  elapsedTime,
  index,
  isPositive,
  pandoraId,
  sourceId,
  stationId,
  trackToken,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.ACTION_REMOVE_THUMB,
    content: {
      deviceProperties,
      deviceUuid,
      elapsedTime,
      index,
      pandoraId,
      sourceId,
      trackToken,
    },
    actionParams: {
      isPositive,
      stationId,
      pandoraId,
    },
    isPositive,
  });
}

export function actionRepeat({ sourceId, mode, prevMode, deviceProperties, deviceUuid }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.ACTION_REPEAT,
    content: {
      sourceId,
      mode,
      deviceProperties,
      deviceUuid,
    },
    prevMode,
  });
}

export function actionReplay({
  deviceProperties,
  deviceUuid,
  elapsedTime,
  index,
  sourceId,
  trackToken,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.ACTION_REPLAY,
    content: {
      deviceProperties,
      deviceUuid,
      elapsedTime,
      index,
      sourceId,
      trackToken,
    },
  });
}

export function actionShuffle({ sourceId, enabled, deviceProperties, deviceUuid }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.ACTION_SHUFFLE,
    content: {
      sourceId,
      enabled,
      deviceProperties,
      deviceUuid,
    },
  });
}

export function actionSkip({
  checkOnly = false,
  deviceProperties,
  deviceUuid,
  elapsedTime,
  index,
  sourceId,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.ACTION_SKIP,
    content: {
      checkOnly,
      deviceProperties,
      deviceUuid,
      elapsedTime,
      includeItem: true,
      index,
      sourceId,
    },
  });
}

export function actionMode({ deviceUuid, elapsedTime, index, modePandoraId, sourceId }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.ACTION_MODE,
    content: {
      deviceUuid,
      elapsedTime,
      endCurrentItem: true,
      includeItem: true,
      index,
      modeId: modePandoraId,
      sourceId,
    },
  });
}

export function actionThumbDown({
  deviceProperties,
  deviceUuid,
  elapsedTime,
  index,
  pandoraId,
  sourceId,
  trackToken,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.ACTION_THUMB_DOWN,
    content: {
      deviceProperties,
      deviceUuid,
      elapsedTime,
      index,
      pandoraId,
      sourceId,
      trackToken,
    },
    isPositive: false,
  });
}

export function actionThumbUp({
  deviceProperties,
  deviceUuid,
  elapsedTime,
  index,
  pandoraId,
  sourceId,
  trackToken,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.ACTION_THUMB_UP,
    content: {
      deviceProperties,
      deviceUuid,
      elapsedTime,
      index,
      pandoraId,
      sourceId,
      trackToken,
    },
    isPositive: true,
  });
}

export function eventEnded({ deviceProperties, deviceUuid, elapsedTime, index, reason, sourceId }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.EVENT_ENDED,
    content: {
      deviceProperties,
      deviceUuid,
      elapsedTime,
      includeItem: true,
      index,
      reason,
      sourceId,
    },
  });
}

export function eventProgress({ deviceProperties, deviceUuid, elapsedTime, index, sourceId }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.EVENT_PROGRESS,
    content: {
      deviceProperties,
      deviceUuid,
      elapsedTime,
      index,
      sourceId,
    },
  });
}

export function eventStarted({ deviceProperties, deviceUuid, elapsedTime, index, sourceId }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.EVENT_STARTED,
    content: {
      deviceProperties,
      deviceUuid,
      elapsedTime,
      index,
      sourceId,
    },
  });
}

export function playbackCurrent({
  cachedAdSourceIdentifierList,
  deviceProperties,
  deviceUuid,
  forceActive,
  sourceId,
  vmapAds,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.PLAYBACK_CURRENT,
    content: {
      cachedAdSourceIdentifierList,
      deviceProperties,
      deviceUuid,
      forceActive,
      sourceId,
      vmapAds,
    },
  });
}

export function playbackPeek({
  cachedAdSourceIdentifierList,
  deviceProperties,
  deviceUuid,
  sourceId,
  vmapAds,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.PLAYBACK_PEEK,
    content: {
      cachedAdSourceIdentifierList,
      deviceProperties,
      deviceUuid,
      sourceId,
      vmapAds,
    },
  });
}

export function playbackSource({
  cachedAdSourceIdentifierList,
  context,
  deviceProperties,
  deviceUuid,
  index,
  itemId,
  onDemandArtistMessageToken,
  repeat,
  shuffle,
  sortOrder,
  sourceId,
  testCreativeId,
  testLineId,
  testMode,
  vmapAds,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.PLAYBACK_SOURCE,
    content: {
      cachedAdSourceIdentifierList,
      clientFeatures: ['RewardInteractions', 'AudioMessages'],
      deviceProperties,
      deviceUuid,
      includeItem: true,
      index,
      itemId,
      onDemandArtistMessageToken,
      repeat,
      shuffle,
      skipExplicitCheck: true,
      sortOrder,
      sourceId,
      testCreativeId,
      testLineId,
      testMode,
      vmapAds,
    },
    context,
  });
}
